import { graphql } from "@opensea/graphql"
import { useCollectionOffersFragment } from "@/components/offers/use-collection-offers.fragment"

export const CollectionItemsMakeOfferButtonFragment = graphql(
  `
    fragment CollectionItemsMakeOfferButton on Collection {
      traitOffersEnabled
      ...useCollectionOffers
    }
  `,
  [useCollectionOffersFragment],
)
